import React from 'react'
import './Heroui.css'
import heroimage from '../Images/heroimageui.png'

function Heroui() {
    return (
        <div id='heroui'>
            <div className="section">
                <div className="container">
                    <div className='heroHeadingBox'>

                        <h1 className='heroHeading'>
                            <span className='heroSpan'>UI/UX</span>
                            {/* Design Services */}
                        </h1>
                        <h1 className='heroHeading'>
                            {/* <span className='heroSpan'>UI/UX</span>  */}
                           Design Services That Transform Ideas
                        </h1>
                        <h3 className="subHeroheading">
UI/UX Design Services That Deliver Results
                        </h3>
                        <p className="subHeading">
                           We deliver the Best UI UX design services by blending creativity with functionality. Every design is crafted to be visually stunning, user-friendly, and conversion-driven—helping businesses attract, engage, and retain customers with seamless digital experiences.
                        </p>
                    </div>
                    <div className="imageBox">
                        <img src={heroimage} alt="error" className='heroImage' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Heroui